import React from 'react';
import Base from './Base';

const DangerButton = (props) => <Base {...props} className="btn--danger" />;

export default DangerButton;